exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".times-1deef003{display:flex;flex-direction:column;margin-bottom:40px}\n", ""]);

// Exports
exports.locals = {
	"times": "times-1deef003"
};